import React from 'react';
import { SwipeableDrawer, Box, useTheme, useMediaQuery } from '@mui/material';

const GRABBER_SX = {
  width: 36,
  height: 4,
  borderRadius: 2,
  bgcolor: 'divider',
  mx: 'auto',
  mt: 1,
  mb: 0.5,
  flexShrink: 0,
};

function DrawerShell({ open, onOpen, onClose, anchor, ariaLabel, children, footer, maxHeight }) {
  const theme = useTheme();
  const isBottom = anchor === 'bottom';

  const paperSx = isBottom
    ? {
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        maxHeight: maxHeight || '92dvh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
      }
    : {
        width: 480,
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
      };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open}
      onOpen={onOpen || (() => {})}
      onClose={onClose}
      disableSwipeToOpen
      aria-label={ariaLabel}
      PaperProps={{ sx: paperSx }}
      ModalProps={{ keepMounted: false }}
    >
      {isBottom && <Box sx={GRABBER_SX} />}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {children}
      </Box>

      {footer && (
        <Box
          sx={{
            flexShrink: 0,
            borderTop: 1,
            borderColor: 'divider',
            px: 2,
            py: 1.5,
            bgcolor: 'background.paper',
            pb: isBottom ? 'max(12px, env(safe-area-inset-bottom))' : 1.5,
          }}
        >
          {footer}
        </Box>
      )}
    </SwipeableDrawer>
  );
}

export default DrawerShell;
